import { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { useGarden } from '../../garden/GardenContext';
import GlobalLog from '../GlobalLog/GlobalLog';
import './Header.css';

interface HeaderProps {
  isMenuOpen: boolean;
  onToggleMenu: () => void;
}

function Header({ isMenuOpen, onToggleMenu }: HeaderProps) {
  const { isEditingShape, toggleEditingShape, zoom, zoomIn, zoomOut, resetZoom } = useGarden();
  const { logout } = useAuth();
  const [isGlobalLogOpen, setIsGlobalLogOpen] = useState(false);

  return (
    <header className="App-header">
      <div className="App-header__title">
        <button
          type="button"
          className={`App-header__menu-button${isMenuOpen ? ' App-header__button--active' : ''}`}
          onClick={onToggleMenu}
          aria-label={isMenuOpen ? 'Close elements menu' : 'Open elements menu'}
          aria-expanded={isMenuOpen}
        >
          <span className="App-header__menu-icon" aria-hidden="true" />
        </button>
        <h1>My Garden</h1>
      </div>
      <div className="App-header__actions">
        <div className="App-header__zoom">
          <button
            type="button"
            className="App-header__button"
            onClick={zoomOut}
            aria-label="Zoom out"
          >
            −
          </button>
          <button
            type="button"
            className="App-header__button App-header__zoom-level"
            onClick={resetZoom}
            title="Reset zoom"
          >
            {Math.round(zoom * 100)}%
          </button>
          <button
            type="button"
            className="App-header__button"
            onClick={zoomIn}
            aria-label="Zoom in"
          >
            +
          </button>
        </div>
        <button
          type="button"
          className={`App-header__button${isEditingShape ? ' App-header__button--active' : ''}`}
          onClick={toggleEditingShape}
        >
          {isEditingShape ? 'Done editing shape' : 'Edit garden shape'}
        </button>
        <button
          type="button"
          className="App-header__button"
          onClick={() => setIsGlobalLogOpen(true)}
        >
          Activity log
        </button>
        <button type="button" className="App-header__button" onClick={() => logout()}>
          Log out
        </button>
      </div>
      {isGlobalLogOpen && <GlobalLog onClose={() => setIsGlobalLogOpen(false)} />}
    </header>
  );
}

export default Header;
